export const aboutComparisonEn = {
  // About — problem platforms
  'about.problem.requires': 'Requires:',
  'about.problem.onlyfans.body': 'A $10k/month creator loses $24,000 per year to fees.',
  'about.problem.onlyfans.requires': 'Bank account + KYC',
  'about.problem.throne.body': 'Plus currency conversion. Plus withdrawal delays. Limited to 10 countries.',
  'about.problem.throne.requires': 'Bank account + KYC',
  'about.problem.linktree.body': "Or pay $40/month for 0% fees. Either way, they're taking your money.",
  'about.problem.linktree.requires': 'Bank account + payment processor',
  'about.problem.kickstarter.body': 'Plus $5K-25K fulfillment costs. All-or-nothing funding.',
  'about.problem.kickstarter.requires': 'Bank account + KYC + fulfillment',
  'about.problem.indiegogo.body': '5% holdback until delivery. 14-day payout delays. Flexible but costly.',
  'about.problem.indiegogo.requires': 'Bank account + KYC + fulfillment',
  'about.problem.katoa.body': 'No fees. No delays. Keep 100% through 31 Dec 2026.',
  'about.problem.katoa.requires': 'No bank account needed. No KYC.',
  'about.problem.avgLoss': 'Average creator loses',
  'about.problem.avgLossAmount': '$12,000-$24,000/year',
  'about.problem.allRequire': 'ALL 5 platforms require:',
  'about.problem.bankAccount': 'Bank account',
  'about.problem.kyc': 'KYC verification',
  'about.problem.processors': 'Payment processors',
  'about.problem.geoLimits': 'Geographic limits',
  'about.problem.katoaRequires': 'KATOA requires: NOTHING',
  'about.problem.katoaWallet': "Just a Bitcoin Lightning wallet. That's it.",

  // About — solution
  'about.solution.title': 'Our Solution: Bitcoin + Decentralization',
  'about.solution.subtitle': 'We built KATOA on technology that makes platform fees impossible.',
  'about.solution.lightning.title': 'Lightning Network',
  'about.solution.lightning.body': "Bitcoin's Lightning Network enables fast, low-cost transactions globally once Lightning receive ships (Roadmap: In progress). No payment processor taking a cut. No 7-day delays. No geographic restrictions.",
  'about.solution.lightning.item1': 'Settlements in under 1 second',
  'about.solution.lightning.item2': 'Works in 195+ countries',
  'about.solution.lightning.item3': 'Micropayments down to satoshis',
  'about.solution.lightning.item4': 'No bank account required',
  'about.solution.nostr.title': 'Nostr Protocol',
  'about.solution.nostr.body': 'A decentralized social protocol that makes censorship impossible. Your account, your data, your rules. No company can ban you or harvest your information.',
  'about.solution.nostr.item1': 'No account suspensions (you own your keys)',
  'about.solution.nostr.item2': 'Opt-in encrypted messaging (NIP-17)',
  'about.solution.nostr.item3': 'Zero-knowledge payment proofs (roadmap)',
  'about.solution.nostr.item4': 'Distributed across relays worldwide',
  'about.solution.result.title': 'The Result: 0% Fees Through 31 Dec 2026',
  'about.solution.result.body': "When payments flow peer-to-peer on Bitcoin, there's no intermediary to extract fees. This isn't a promotional rate. It's how the technology works.",

  // About — values
  'about.values.title': 'What We Stand For',
  'about.values.creators.title': 'Creators First',
  'about.values.creators.desc': 'Every decision we make prioritizes creator earnings and freedom.',
  'about.values.privacy.title': 'Privacy Always',
  'about.values.privacy.desc': 'Minimal data collection. Non-custodial payments. Your keys stay yours.',
  'about.values.global.title': 'Truly Global',
  'about.values.global.desc': 'No geographic discrimination. Bitcoin works everywhere, for everyone.',
  'about.values.censorship.title': 'Censorship Proof',
  'about.values.censorship.desc': 'Decentralized by design. No company can ban you or control your content.',

  // About — competitors
  'about.competitors.title': 'Why Every Competitor Falls Short',
  'about.competitors.subtitle': 'They all have the same fundamental flaw: dependence on traditional banking systems.',
  'about.competitors.onlyfans.title': 'OnlyFans: 20% Platform Tax',
  'about.competitors.onlyfans.body': 'A creator making $10K/month loses $2,000 per month ($24K/year). Plus censorship risk from Mastercard/Visa. Plus account suspension without appeal.',
  'about.competitors.kickstarter.title': 'Kickstarter: Fulfillment Nightmare',
  'about.competitors.kickstarter.body': "5% platform + payment processing (typically ~8–10% all-in), plus $5K-25K+ fulfillment costs. All-or-nothing funding means if you don't hit your goal, you get $0.",
  'about.competitors.indiegogo.title': 'Indiegogo: Hidden Holdbacks',
  'about.competitors.indiegogo.body': "8-15% total fees including 5% holdback until delivery. Flexible funding sounds good until you realize they're holding your money hostage.",
  'about.competitors.linktree.title': 'Linktree: Pay-to-Win Monetization',
  'about.competitors.linktree.body': 'Free tier: 10% fees. Or pay $40/month ($480/year) for 0% fees. Either way, you lose money just to have a landing page.',
  'about.competitors.throne.title': 'Throne: the 0% math',
  'about.competitors.throne.body': 'Advertises "0% fees"; typical all-in is ~10%. The 0% rate is limited to ~10 countries — elsewhere you pay the rest.',
  'about.competitors.con.bankKyc': 'Requires bank account + KYC',
  'about.competitors.con.payout7': '7-day payout delays',
  'about.competitors.con.payout14': '14+ day payout delays',
  'about.competitors.con.censorship': 'Payment processor censorship',
  'about.competitors.con.countries': 'Limited to supported countries',
  'about.competitors.con.fulfillment': 'Shipping/fulfillment stress',
  'about.competitors.con.oneTime': 'One-time funding only',
  'about.competitors.con.holdback': '5% held until product delivery',
  'about.competitors.con.fulfillmentReq': 'Fulfillment required',
  'about.competitors.con.processor': 'Requires payment processor',
  'about.competitors.con.geoRestrict': 'Geographic restrictions',
  'about.competitors.con.feesOrSub': '9-10% fees or $480/year',
  'about.competitors.con.countries50': 'Limited to 50 countries',
  'about.competitors.con.withdraw7': '7-day withdrawal delays',
  'about.competitors.con.countries10': 'Limited to 10 countries for 0%',
  'about.competitors.con.conversion': 'Hidden currency conversion fees',
  'about.competitors.katoa.title': 'KATOA: The Only Real Alternative',
  'about.competitors.katoa.body': 'Lightning routing/network fees are paid by supporters. We\'ll publish any change before the window ends.',
  'about.competitors.katoa.fee': '0% platform fees through 31 December 2026',
  'about.competitors.katoa.feeDesc': 'Absorbed by Give A Bit and community support',
  'about.competitors.katoa.payout': 'Fast payouts (Roadmap)',
  'about.competitors.katoa.payoutDesc': 'Via Lightning — once receive ships (Roadmap: In progress).',
  'about.competitors.katoa.bank': '✓ No Bank Needed',
  'about.competitors.katoa.bankDesc': 'Just a Lightning wallet.',
  'about.competitors.katoa.global': '✓ 195+ Countries',
  'about.competitors.katoa.globalDesc': 'Works everywhere equally.',

  // About — audience
  'about.audience.title': 'Who We Serve',
  'about.audience.subtitle': 'KATOA was built for creators the traditional platforms ignore.',
  'about.audience.unbanked.title': 'The Unbanked',
  'about.audience.unbanked.body': "Creators in Argentina, Nigeria, Venezuela, Vietnam. Countries where Stripe and PayPal don't work.",
  'about.audience.unbanked.stat': '195+ countries supported',
  'about.audience.privacy.title': 'The Privacy-Conscious',
  'about.audience.privacy.body': 'Creators who refuse to be surveilled. Who want end-to-end encryption. Who demand data sovereignty.',
  'about.audience.privacy.stat': 'Minimal data, non-custodial',
  'about.audience.ambitious.title': 'The Ambitious',
  'about.audience.ambitious.body': 'Creators earning $10k-$100k+ per month who are sick of losing 10-20% to platform fees.',
  'about.audience.ambitious.stat': 'Save $12k-$240k annually',

  // About — team
  'about.team.title': 'Built by Creators, For Creators',
  'about.team.body1': "We're a team of creators who got fed up with losing 10-20% of our earnings to platforms. So we built something better.",
  'about.team.body2': "We're not venture-backed. We don't answer to investors demanding user growth at all costs. We answer to creators. That's why we'll never charge fees.",
  'about.team.promise': 'Our Promise',
  'about.team.promise1': 'We will never charge platform fees',
  'about.team.promise2': 'We will never harvest your data',
  'about.team.promise3': 'We will never ban creators for lawful content',
  'about.team.promise4': 'We will always prioritize your earnings over ours',

  // About — CTA
  'about.cta.title': 'Join the Movement',
  'about.cta.subtitle': 'Early days — join creators keeping 100%. 0% platform fees through 31 Dec 2026.',
  'about.cta.highlight': 'Be next.',
  'about.cta.start': 'Start Earning 100%',
  'about.cta.compare': 'See the Numbers',
  'about.cta.footer': 'No fees. No KYC. No catches. Just you keeping 100%.',

  // Comparison — UI chrome
  'comparison.badge': 'Honest Comparison • No Marketing Spin',
  'comparison.earningsLabel': 'Your monthly earnings (USD)',
  'comparison.savingsYearly': "Based on ${amount}/mo earnings — that's ${yearly}/year back in your pocket.",
  'comparison.savingsVs': 'vs OnlyFans (${onlyfans}) · Throne (${throne}) · Linktree (${linktree})',
  'comparison.adjustCalc': 'Adjust in calculator ↓',
  'comparison.breakdown.title': 'Feature-by-Feature Breakdown',
  'comparison.table.feature': 'Feature',
  'comparison.table.swipe': 'Swipe for more',
  'comparison.card.countries.title': '195+ Countries',
  'comparison.card.countries.body': 'No bank account? No problem. Bitcoin works everywhere, for everyone. No discrimination.',
  'comparison.card.countries.throne': 'Throne: ~10 countries with 0% fees',
  'comparison.card.countries.katoa': 'KATOA: All countries, 0% through 31 Dec 2026',
  'comparison.card.privacy.title': 'True Privacy',
  'comparison.card.privacy.body': 'Minimal data collection. Non-custodial by design. Encrypted messaging is opt-in (NIP-17). Zero-knowledge proofs are on the roadmap.',
  'comparison.card.privacy.others': 'Others: Your data is their product',
  'comparison.card.privacy.katoa': 'KATOA: non-custodial, minimal data',
  'comparison.card.instant.title': 'Fast settlement (Roadmap)',
  'comparison.card.instant.body': 'Keep 100% of your earnings. Scale globally. Build your empire without platform taxes.',
  'comparison.card.instant.others': 'Others: Wait 7-14 days for payouts',
  'comparison.card.instant.katoa': 'KATOA: Instant Lightning Network (with Lightning receive — see Roadmap)',
  'comparison.cta.title': 'Ready to Keep 100%?',
  'comparison.cta.subtitle': 'Join early. 0% platform fees. Keep what supporters send — Lightning network fees still apply.',
  'comparison.cta.start': 'Start Earning 100%',
  'comparison.cta.pricing': 'See Pricing (Spoiler: $0)',

  // Comparison — feature categories
  'comparison.cat.fees': 'Fees & Costs',
  'comparison.cat.banking': 'Banking Requirements',
  'comparison.cat.global': 'Global Reach',
  'comparison.cat.payout': 'Payout Speed',
  'comparison.cat.revenue': 'Revenue Models',
  'comparison.cat.privacy': 'Privacy & Security',
  'comparison.cat.payment': 'Payment Features',
  'comparison.cat.control': 'Platform Control',

  // Comparison — feature rows
  'comparison.feat.platformFees': 'Platform Fees',
  'comparison.feat.paymentProcessing': 'Payment Processing',
  'comparison.feat.totalFee10k': 'Total Fee on $10K',
  'comparison.feat.monthlySub': 'Monthly Subscription',
  'comparison.feat.withdrawalFees': 'Withdrawal Fees',
  'comparison.feat.hiddenCosts': 'Hidden Costs',
  'comparison.feat.bankRequired': 'Bank Account Required',
  'comparison.feat.kyc': 'KYC/Identity Verification',
  'comparison.feat.noBanking': 'Works Without Banking',
  'comparison.feat.processorDep': 'Payment Processor Dependent',
  'comparison.feat.countries': 'Countries Supported',
  'comparison.feat.sanctioned': 'Bitcoin is global',
  'comparison.feat.instantIntl': 'Fast international transfers (Roadmap)',
  'comparison.feat.conversion': 'Currency Conversion Fees',
  'comparison.feat.payoutTime': 'Payout Time',
  'comparison.feat.instantSettlement': 'Fast settlement (Roadmap)',
  'comparison.feat.holdback': 'Fund Holdback',
  'comparison.feat.crowdfunding': 'Crowdfunding/Projects',
  'comparison.feat.subscriptions': 'Subscriptions (demo)',
  'comparison.feat.tips': 'Tips/Donations',
  'comparison.feat.digital': 'Digital Products',
  'comparison.feat.fulfillment': 'Fulfillment Required',
  'comparison.feat.zk': 'Zero-Knowledge Proofs (roadmap)',
  'comparison.feat.encrypted': 'Encrypted messaging (opt-in NIP-17)',
  'comparison.feat.decentralized': 'Decentralized Infrastructure',
  'comparison.feat.censorship': 'Censorship Resistant',
  'comparison.feat.micro': 'Micropayments Support',
  'comparison.feat.bolt12': 'BOLT 12 Recurring (planned)',
  'comparison.feat.lightning': 'Lightning Network',
  'comparison.feat.multiRevenue': 'Multiple Revenue Streams',
  'comparison.feat.suspension': 'Account Suspension Risk',
  'comparison.feat.contentCensor': 'Content Censorship',
  'comparison.feat.ownData': 'Own Your Data',
  'comparison.feat.ownKeys': 'Own Your Keys',

  'comparison.cell.instant': 'Fast',
  'comparison.cell.none': 'None',
  'comparison.cell.varies': 'Varies',
  'comparison.cell.included': 'Included',
  'comparison.cell.limited': 'Limited',
  'comparison.cell.demo': 'Demo',
  'comparison.cell.planned': 'Planned',
  'comparison.cell.roadmap': 'Roadmap',

  'comparison.metaTitle': 'Platform Comparison',
  'comparison.metaDesc': 'Compare KATOA vs OnlyFans, Throne, Kickstarter, and more. 0% platform fees, Lightning settlement, no KYC to start.',
} as const;